import { motion } from "framer-motion";
import { WHY } from "@/lib/data";
import { fadeUp, stagger, viewport } from "@/lib/motion";

const ABOUT_IMG =
  "https://images.pexels.com/photos/28958875/pexels-photo-28958875.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export default function WhyKazakhstan() {
  return (
    <section id="neden" data-testid="why-section" className="py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          variants={stagger}
          initial="hidden"
          whileInView="show"
          viewport={viewport}
          className="max-w-2xl mb-14"
        >
          <motion.span variants={fadeUp} className="text-sm uppercase tracking-[0.2em] text-[#1B19A8] font-semibold">
            01 · Neden Kazakistan?
          </motion.span>
          <motion.h2 variants={fadeUp} className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-[#1a1a1a] mt-4 leading-tight">
            Hayalindeki bölüme <span className="text-[#1B19A8]">engelsiz</span> giden yol.
          </motion.h2>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-5">
          {/* image card spanning */}
          <motion.div
            variants={fadeUp}
            initial="hidden"
            whileInView="show"
            viewport={viewport}
            className="md:row-span-2 relative rounded-3xl overflow-hidden min-h-[320px] shadow-[0_8px_32px_rgba(0,0,0,0.06)]"
          >
            <img src={ABOUT_IMG} alt="Almatı şehri ve dağ manzarası" className="absolute inset-0 w-full h-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#1a1a1a]/85 via-[#1a1a1a]/20 to-transparent" />
            <div className="absolute bottom-0 p-7 text-white">
              <div className="text-sm uppercase tracking-[0.15em] text-[#FFE500] font-semibold mb-1">Almatı & Astana</div>
              <p className="font-display text-2xl font-bold leading-snug">{"Modern kampüsler, güvenli şehirler, kültürel olarak yakın."}</p>
            </div>
          </motion.div>

          {WHY.map((w, i) => (
            <motion.div
              key={w.title}
              variants={fadeUp}
              initial="hidden"
              whileInView="show"
              viewport={viewport}
              custom={i}
              whileHover={{ y: -4 }}
              className="rounded-3xl bg-white border border-black/5 p-8 shadow-[0_8px_32px_rgba(0,0,0,0.04)]"
            >
              <span className="grid place-items-center w-12 h-12 rounded-2xl bg-[#1B19A8]/8 text-[#1B19A8] mb-5">
                <w.icon size={24} strokeWidth={2} />
              </span>
              <h3 className="font-display text-xl font-bold text-[#1a1a1a] mb-2">{w.title}</h3>
              <p className="text-[#1a1a1a]/60 leading-relaxed">{w.text}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
